const makeCookieOption = (LIB) => {
    return function makeCookieOption (optionName, type) {
        window[optionName] = function (value) {
            if (type == 'string') {
                LIB.COOKIE.set(optionName, value);
            }
        }   
    }
}

export default makeCookieOption;